import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AutocompleteItem } from 'src/app/core/components/autocomplete/autocomplete-item';
import { AutocompleteItemsService } from 'src/app/core/components/autocomplete/autocomplete-items.service';
import { ErrorService } from 'src/app/core/error-handling/error.service';
import { NotificationService } from 'src/app/core/notifications/notification.service';
import { TekstResourcePipe } from 'src/app/core/pipes/tekstresource.pipe';
import { GeoSearchService } from '../../../services/geosearch/geosearch.service';

@Injectable({
  providedIn: 'root',
})
export class MatrikelsoegningService implements AutocompleteItemsService {
  private canShowError = true;

  constructor(
    private geoSearchService: GeoSearchService,
    private errorService: ErrorService,
    private notifikationService: NotificationService,
    private tekstResourcePipe: TekstResourcePipe
  ) {}

  getAutocompleteItems(term: string): Observable<AutocompleteItem[]> {
    if (!term) {
      return of([]);
    }

    return this.geoSearchService.searchMatrikel(term).pipe(
      map(response => {
        if (response.data) {
          return response.data.map(i => ({
            label: i.visningstekst,
            value: i,
          }));
        } else {
          return null;
        }
      }),
      catchError(error => this.onError(error))
    );
  }

  onError(error: any): Observable<any> {
    if (this.canShowError) {
      this.canShowError = false;
      this.errorService.log(error).subscribe(response => {
        this.notifikationService.error(
          this.tekstResourcePipe.transform('Fejl.Notifikation.GeoService.Error'),
          null,
          response.correlationId
        );
      });
      setTimeout(() => {
        this.canShowError = true;
      }, 10000);
    }
    return of();
  }
}
